import { useDispatch } from 'react-redux';
import { EnrollmentOptions } from '../models/new-hire-enrollment-models';
import { WhoWillEnrollCriterias, WhoWillEnrollOptions } from '../models/who-will-enroll-models';
import { setWhoWillEnrollCriteria } from '../slice/new-hire-enrollment-slices';

function getDefaultOption(option: any) {
    if (option?.admin && option?.member) {
        return null;
    }
    if (option?.admin) {
        return WhoWillEnrollOptions.admin;
    }
    if (option?.member) {
        return WhoWillEnrollOptions.member;
    }

    return null;
}

export function getWhoWillEnrollCriterias(options: EnrollmentOptions): WhoWillEnrollCriterias{
    return {
        memberOrAdmin: null,
        pension: getDefaultOption(options?.benefit_options?.pension),
        medical: getDefaultOption(options?.benefit_options?.medical),
        dental: getDefaultOption(options?.benefit_options?.dental),
        disability: getDefaultOption(options?.benefit_options?.disability),
        ltd: getDefaultOption(options?.benefit_options?.ltd),
        std: getDefaultOption(options?.benefit_options?.std),
    };
}

export function storeLocalStorageSelections(selections: WhoWillEnrollCriterias) {
    localStorage.setItem('whoWillEnrollSelections', JSON.stringify(selections));
}

export function getLocalStorageSelections(): WhoWillEnrollCriterias {
    const selections = localStorage.getItem('whoWillEnrollSelections');
    return selections ? JSON.parse(selections) : null;
}

export function verifyAndFillSelections(whoWillEnroll: WhoWillEnrollCriterias) {
    const dispatch = useDispatch();
    const selections = getLocalStorageSelections();

    if (!selections) {
        return;
    }

    if (!whoWillEnroll){
        dispatch(setWhoWillEnrollCriteria(selections));
        return;
    }
    
    const isEmpty = Object.values(whoWillEnroll).every(prop => prop === null || prop === undefined || prop === '');
    
    if (isEmpty) {
        dispatch(setWhoWillEnrollCriteria(selections));
    }
}

export function clearLocalStorageSelections() {
    localStorage.removeItem('whoWillEnrollSelections');
}